import React, {useEffect, useReducer, useState} from "react";
import Editor from 'react-medium-editor';
import MediumEditorSubcomponent from "./MediumEditorSubcomponent";
import {Tooltip} from "@mui/material";

const reducer = (state, action) => {
    var v = action.i;
    return {...state, [v]: action.ok}
}

const initialState = {}
export default function FilltextSubcomponent(props) {
    const [filltext, setFilltext] = useState(props.filltext)
    const [filltextinfo, setFilltextinfo] = useState([])
    const [ok, setOk] = useState(false)

    const [state, dispatch] = useReducer(reducer, initialState)

    useEffect(() => {
        var ft = myFunction(filltext);
        setFilltextinfo(ft);
        ft.map(
            (k, i) => {
                if (k['type'] === 'fill') {
                    dispatch({i: 'x:' + i, ok: false})
                }
            }
        )
    }, [filltext]);

    useEffect(() => {
        var isOk = true;
        Object.entries(state).map(
            ([k, v]) => {
                isOk = isOk && v
            }
        )
        setOk(isOk)
    }, [state]);

    function handleChange(e) {
        // setFilltextinfo({...filltextinfo, murks: v });
        // console.log("FilltextComponent.handleChange(e=" + e + ")")
        dispatch({i: e.mykey, ok: e.ok})
    }

    return (
        <>
            {/*<p>{filltext}</p>*/}
            {/*<p style={{border: (ok) ? 'none': '1px solid red', display: "inline-flex"}}>OK={ok.toString()}</p>*/}
            {
                filltextinfo.map(
                    (k, i) => {
                        if (k['type'] === 'text') {
                            return k['content']
                        } else if (k['type'] === 'fill') {
                            return (
                                <Tooltip
                                    key={i}
                                    title={props.showSolution ? k['content'] : ''}
                                ><span style={{wordWrap: 'anywhere'}}><MediumEditorSubcomponent
                                        // tag="span"
                                        key={'x:' + i}
                                        mykey={'x:' + i}
                                        expectedtext={k['content']}
                                        showFeedback={props.showFeedback}
                                        onChange={handleChange}
                                        // style={{backgroundColor: 'cyan'}}
                                        // options={{ toolbar: { buttons: ['bold', 'italic', 'underline'] } }}
                                    /></span>
                                </Tooltip>
                            )
                        }
                    }
                )
            }
            {/*<pre>state = {JSON.stringify(state, null, 2)}</pre>*/}
        </>
    );
}

function myFunction(line) {
    const re = /{(.+?)}/g;
    var s = line; //filltextlist.toString();
    // s = "m {a} x {b} y {c} n";
    // s = "{a} x {b} y {c}";
    //s = "{x}"
    //s = "x"
    var m;
    var current_pos = 0;
    var t = "";
    var arr = [];
    do {
        m = re.exec(s);
        if (m) {
            // console.log(m.index + " " + m[0].toString().length + ' ' + m[0]);
            // console.log(s.substring(m.index, m.index + m[0].toString().length));
            // console.log(s);
            // console.log(s.substring(current_pos, m.index));
            if (t != "") {
                t += "]"
            }
            arr.push({'type': 'text', 'content': s.substring(current_pos, m.index)});
            t += s.substring(current_pos, m.index) + "[";
            arr.push({'type': 'fill', 'content': m[1]});
            t += m[1]
            current_pos = m.index + m[0].toString().length;
        }
    } while (m);
    if (t != "") {
        t += "]"
    }
    t += s.substring(current_pos, s.length);
    arr.push({'type': 'text', 'content': s.substring(current_pos, s.length)});
    // console.log('"' + t + '"');
    // console.log(arr);
    return arr;
}
